module.exports = __webpack_public_path__ + "img/join_img1.8689b25f.jpg";